'use strict';

var _ = require('lodash');
var Params = function Params(axisDirection) {
  return function (containerWidth, containerHeight, zoomScaleExtent) {
    var yAxisLabelShift = axisDirection === 'right-to-left' ? 50 : 40;
    var padding = axisDirection === 'right-to-left' ? _.assign({
      top: 10,
      bottom: 45
    }, {
      left: 10,
      right: 70
    }) : _.assign({
      top: 10,
      bottom: 45
    }, {
      left: 70,
      right: 10
    });
    var width = containerWidth - (padding.left + padding.right);
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      zoomScaleExtent: zoomScaleExtent,
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      xNumberOfTicks: 13,
      yNumberOfTicks: 8,
      xAxisLabelShift: 35,
      yAxisShift: 5,
      yAxisLabelShift: yAxisLabelShift,
      yAxisLabelRightShift: 50
    };
  };
};
module.exports = Params;